export enum WellKnownLayoutApiErrorCodes {
    LayoutNotFound = 'Layout/LAYOUT_NOT_FOUND',
    LayoutNewNameAlreadyExists = 'Layout/LAYOUT_NEW_NAME_ALREADY_EXISTS',
    ShareNotAllowedAsTargetuserOwnsLayout = 'SHARE_NOT_ALLOWED_AS_TARGET_USER_OWNS_LAYOUT',
    CouldNotFindUniqueName = 'COULD_NOT_FIND_UNIQUE_NAME',
}

export function isWellKnownLayoutApiErrorResponse(
    error: unknown,
    code: WellKnownLayoutApiErrorCodes
) {
    return (
        hasErrorCode(error, code) ||
        hasErrorCode((error as { data: unknown })?.data, code)
    );
}

function hasErrorCode(error: unknown, code: WellKnownLayoutApiErrorCodes) {
    const err = error as {
        status: number;
        errorCode: WellKnownLayoutApiErrorCodes;
    };

    return err && err.status === 400 && err.errorCode === code;
}
